import { UI_CARD } from "lib/uiClasses";

function Card(props: {
  variant?: string;
  extra?: string;
  children?: JSX.Element | any[];
  [x: string]: any;
}) {
  const { extra, children, ...rest } = props;
  return (
    <div className={`relative flex flex-col bg-clip-border ${UI_CARD} ${extra ?? ""}`} {...rest}>
      {children}
    </div>
  );
}

export default Card;
